import { useEffect, useState } from 'react';

export const useCancelDialog = () => {
  const query = new URLSearchParams(window.location.search);
  const isCancel = query.get('isCancel');
  const isConfirm = query.get('isConfirm');
  const uuid = query.get('id');
  const subject = query.get('subject');
  const [loading, setIsLoading] = useState(false);

  const handleCancel = async () => {
    if (uuid && subject) {
      setIsLoading(true);

      const body = {
        uuid,
        subject,
        action: isConfirm ? 'confirm' : isCancel ? 'cancel' : '',
      };

      let req;

      if (isCancel) {
        if (window.confirm('確定取消報名？')) {
          req = await fetch(
            'https://cloud.ievent.tw/bi/physical-patient-education-symposium/api/action',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(body),
            }
          );
        } else {
          setIsLoading(false);
          window.location.href =
            'https://cloud.ievent.tw/bi/physical-patient-education-symposium';
          return;
        }
      } else if (isConfirm) {
        req = await fetch(
          'https://cloud.ievent.tw/bi/physical-patient-education-symposium/api/action',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          }
        );
      }

      if (req) {
        const res = await req.json();
        if (res.success) {
          window.location.href =
            'https://cloud.ievent.tw/bi/physical-patient-education-symposium';
        }
      }

      alert(
        isCancel
          ? '已取消報名。'
          : isConfirm
          ? '確認出席！我們活動當天見。'
          : ''
      );

      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleCancel();
  }, []);

  return { loading };
};
